export interface OrttoEmail {
  ID: string;
  MarketCountry: string;
  CustomerID: string;
  CampaignName: string;
  EmailHTMLID: string;
  CreatedAt: string;
  OrttoEmailStatusUpdates: OrttoEmailStatusUpdate[];
}

export interface OrttoEmailStatusUpdate {
  ID: string;
  OrttoEmailID: string;
  Status: OrttoEmailStatus;
  CreatedAt: string;
  WebhookReceivedAt: string;
}

export enum OrttoEmailStatus {
  Sent = 'sent',
  Received = 'received',
  Opened = 'opened',
  Clicked = 'clicked',
  Bounced = 'bounced',
}

export interface OrttoEmailHTML {
  ID: string;
  HTML: string;
  CreatedAt: string;
  MarketCountry: string;
  Subject: string;
  CustomerID: string;
}
